import { Injectable } from '@angular/core';
import { Entity, BindingData, FrameContext } from '@farris/devkit';
import { BefRepository } from '@farris/bef';
import { Observable, EMPTY } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { LanguageService } from '../languag.service';
import { FormErrorService } from '../error/form-error.service';
import { EditStateUtil } from './utils/index';


/**
 * æ°æ®ç¼è¾æå¡
 */
@Injectable()
class EditDataService {

  /**
   * å®ä½ä»åº
   */
  private repository: BefRepository<Entity>;

  /**
   * ç»å®æ°æ®
   */
  private bindingData: BindingData;

  /**
   * Loadingæå¡
   */
  private loadingService: FormLoadingService;

  /**
   * è¯­è¨æå¡
   */
  private languageService: LanguageService;

  /**
   * éè¯¯å¤çæå¡
   */
  private errorService: FormErrorService;

  /**
   * æé å½æ°
   */
  constructor(private frameContext: FrameContext) {
    this.repository = this.frameContext.repository as BefRepository<Entity>;
    this.bindingData = this.frameContext.bindingData;
    this.loadingService = this.frameContext.injector.get<FormLoadingService>(FormLoadingService, null);
    this.languageService = this.frameContext.injector.get<LanguageService>(LanguageService, null);
    this.errorService = this.frameContext.injector.get<FormErrorService>(FormErrorService, null);
  }

  /**
   * ç¼è¾ï¼æ¯æå éï¼
   */
  public edit(id: string): Observable<Entity> {

    id = id || this.bindingData.list.currentId;
    if (!id) {
      return EMPTY;
    }

    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const edit$ = this.repository.editEntityById(id);
    const result$ = edit$.pipe(
      tap(
        () => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          EditStateUtil.setEditState(this.frameContext, id);
        },
        (error: any) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.errorService.exception(this.languageService.updateFailed, error);
        }
      )
    );
    return result$;
  }
}


export { EditDataService };
